import { api } from '@shared/api';
import type {
  AcceptInviteRequest,
  AccessTokenResponse,
  ListEnvelope,
  LoginRequest,
  LoginResponse,
  MeResponse,
  MeUpdate,
  MfaSetupResponse,
  MfaVerifyResponse,
  RegisterRequest,
  RegisterResponse,
  SessionView,
} from '@shared/api/types';

/** Endpoints of apps/api/tibyan/auth/router.py (API spec §2.1–2.2). */
export const authApi = {
  register: (body: RegisterRequest) => api.post<RegisterResponse>('/auth/register', body, { auth: false }),
  verifyEmail: (token: string) => api.post<void>('/auth/verify-email', { token }, { auth: false }),
  resendVerification: (email: string) => api.post<{ accepted: boolean }>('/auth/resend-verification', { email }, { auth: false }),
  login: (body: LoginRequest) => api.post<LoginResponse>('/auth/login', body, { auth: false, organizationId: null }),
  logout: () => api.post<void>('/auth/logout', undefined, { stepUp: false }),
  forgotPassword: (email: string) => api.post<{ accepted: boolean }>('/auth/password/forgot', { email }, { auth: false }),
  resetPassword: (token: string, password: string) =>
    api.post<void>('/auth/password/reset', { token, password }, { auth: false }),
  acceptInvite: (body: AcceptInviteRequest) =>
    api.post<LoginResponse>('/auth/accept-invite', body, { auth: false, organizationId: null }),
  stepUp: (body: { password?: string; totp_code?: string }) =>
    api.post<AccessTokenResponse>('/auth/step-up', body, { stepUp: false }),
  mfaSetup: () => api.post<MfaSetupResponse>('/auth/mfa/setup'),
  mfaVerify: (code: string) => api.post<MfaVerifyResponse>('/auth/mfa/verify', { code }),
  sessions: () => api.get<ListEnvelope<SessionView>>('/auth/sessions'),
  revokeSession: (id: string) => api.delete<void>(`/auth/sessions/${encodeURIComponent(id)}`),
  me: () => api.get<MeResponse>('/users/me'),
  updateMe: (body: MeUpdate) => api.patch<MeResponse>('/users/me', body),
  switchOrganization: (organizationId: string) =>
    api.post<AccessTokenResponse>('/users/me/active-organization', { organization_id: organizationId }, { organizationId: null }),
};

export const authKeys = {
  all: ['auth'] as const,
  me: () => [...authKeys.all, 'me'] as const,
  sessions: () => [...authKeys.all, 'sessions'] as const,
};
